<template>
  <v-container class="pa-0 ma-0 about-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <v-row class="ma-0 pa-0">
      <v-col class="col-12 col-md-6 pa-0">
        <v-list two-line class="transparent pa-0">
          <v-list-item class="contacts-item d-flex align-center pa-0 mb-5">
            <v-list-item-icon class="ma-0 my-auto mr-4">
              <v-icon>mdi-email</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                this.$t('Contacts').email
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="contacts-item d-flex align-center pa-0 mb-5">
            <v-list-item-icon class="ma-0 my-auto mr-4">
              <v-icon>mdi-phone</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="pa-0">
              <v-list-item-title>{{
                this.$t('Contacts').phone
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="contacts-item d-flex align-center pa-0 mb-5">
            <v-list-item-icon class="ma-0 mt-3 mr-4">
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{
                this.$t('Contacts').address.line0
              }}</v-list-item-title>
              <v-list-item-title>{{
                this.$t('Contacts').address.line1
              }}</v-list-item-title>
              <v-list-item-title>{{
                this.$t('Contacts').address.line2
              }}</v-list-item-title>
              <v-list-item-title
                >{{ this.$t('Contacts').address.postalCode }}
                {{ this.$t('Contacts').address.city }} —
                {{ this.$t('Contacts').address.country }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="contacts-item d-flex align-center pa-0 mb-5">
            <v-btn
              v-for="social in socialMedia"
              :key="social.id"
              class="mr-5"
              icon
              :href="social.url"
              target="_blank"
            >
              <v-icon size="24px">{{ social.icon }}</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col class="col-12 col-md-6 pa-0 mb-5">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3112.3012451294594!2d-9.162346384654473!3d38.73384887959632!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd193313162f5609:0x602582a64bb46440!2sReitoria da Universidade Nova de Lisboa!5e0!3m2!1spt-PT!2spt!4v1607659418608!5m2!1spt-PT!2spt"
          width="100%"
          height="360"
          frameborder="0"
          style="border:0;"
          allowfullscreen
          aria-hidden="false"
          tabindex="0"
        ></iframe>
      </v-col>
    </v-row>

    <ContactForm />
  </v-container>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
  name: 'Contacts',
  components: {
    ContactForm,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      socialMedia: [
        {
          id: 1,
          icon: 'mdi-facebook',
          url: this.$t('Contacts').socials.facebook,
        },
        {
          id: 2,
          icon: 'mdi-twitter',
          url: this.$t('Contacts').socials.twitter,
        },
        {
          id: 3,
          icon: 'mdi-linkedin',
          url: this.$t('Contacts').socials.linkedin,
        },
        {
          id: 4,
          icon: 'mdi-instagram',
          url: this.$t('Contacts').socials.instagram,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.contacts-item {
  font-family: $body-font-family;
  font-weight: normal;
  font-size: 16px;
  min-height: 40px !important;
}
</style>
